// extracted by mini-css-extract-plugin
export default {"container":"Feed_container__ung5H","icons":"Feed_icons__3Z0aM","iconsWithStepper":"Feed_iconsWithStepper__Tk-jT"};